import React from "react";
import { useRoutes } from "react-router-dom";
import { withRouter } from "../../util/with-router";
import { TransitionGroup } from "react-transition-group";
import CustomersList from "./customers-list";
import AddCustomer from "./add-customer";
import * as paths from "../../constants/route-paths";
import RBACApplicationAuth from "../../layout/rbac";

function CustomRoutes({ location }) {
  let element = useRoutes([
    {
      path: ``,
      element: <RBACApplicationAuth moduleURL={location.pathname} component={CustomersList} />,
    },
    {
      path: `${paths.ADD_CUSTOMER}`,
      element: <RBACApplicationAuth moduleURL={location.pathname} component={AddCustomer} />,
    },
    {
      path: `${paths.EDIT_CUSTOMER}`,
      element: <RBACApplicationAuth moduleURL={location.pathname} component={AddCustomer} />,
    },
  ]);

  return element;
}

class Root extends React.PureComponent {
  render() {
    const { location } = this.props;
    return (
      <div className="clearfix" style={{ width: "100%" }}>
        <TransitionGroup>
          <CustomRoutes location={location} />
        </TransitionGroup>
      </div>
    );
  }
}
export default withRouter(Root);
